export enum AuthType {
  Undefined = 0,
  ABOOK = 1,
  KK = 2,
}

export enum BookingType {
  Undefined = 0,
  Booking = 1,
  Association = 2,
  Blocked = 3,
  Fixed = 11,
}

export enum BookingTypeName {
  UNDEFINED = -1,
  NEW = 0,
  BOOKING = 1,
  UNION = 2, // association
  BLOCKED = 3,
  BLOCKED_MAINTENANCE = 4,
  BLOCKED_CONSTRUCTION = 5,
  BLOCKED_PREPARATION = 6,
  BLOCKED_OWN_USAGE = 7,
  BLOCKED_HOLIDAY = 8,
  BLOCKED_VACATION = 9,
  BLOCKED_CORONA = 10,
  FIXED = 11,
  BLOCKED_CULTURE_AND_ACTIVITIES = 12,
  BLOCKED_INTERNAL_MEETING = 13,
  BLOCKED_OPERATIONAL_CLOSURE = 14,
  BLOCKED_HOLIDAY_CLOSURE = 15,
  MATCH = 17,
  EVENT = 18,
}

export enum BookingStatus {
  New = 0,
  Pending = 1,
  Request = 2,
  Completed = 3,
  Cancel = 4,
  Rejected = 5,
}

export enum Role {
  Undefined = 0,
  SuperAdmin = 1,
  AdminArea = 84,
  Admin = 2,
  AdminReadOnly = 85,
  AdminReadOnlyAllLocations = 86,
  User = 3,
  Company = 4,
  KKInternal = 72,
  Association = 15,
  AssociationAdmin = 16,
  AssociationUser = 17,
  /** Virksomhedsansvarlig: administers a company's bookings (#797). */
  CompanyAdmin = 19,
  /** Virksomhedsbooker: books for a company (#797). */
  CompanyBooker = 20,
  /** Intern ansvarlig: administers an internal customer's bookings (#797). */
  InternalAdmin = 21,
  /** Intern booker: books for an internal customer (#797). */
  InternalBooker = 22,
  InternalUser = 6,
}

export enum SearchMode {
  BookingPeriod = 1,
  BookingCreatedOn = 2,
}

export enum BalanceSearchMode {
  CreatedOn = 1,
  ApprovedOn = 2,
}

export enum NotificationType {
  Custom_Standard = 1000,
  Booking_Confirmation = 1100,
  Booking_PaymentPending = 1110,
  Booking_Cancellation = 1200,
  Booking_RenewFixedBooking = 5505,
}

export enum ScheduleType {
  Booking = 0,
  Offer = 1,
  Fixed = 2,
}

/**
 * Perioden en prisperiodes maksimumtid måles over. Altid den kalenderperiode bookingen ligger i —
 * kvoten nulstilles ved midnat, mandag og den 1. i måneden.
 */
export enum BookingLimitPeriod {
  Day = 1,
  Week = 2,
  Month = 3,
}

/**
 * Perioderne som de vises, med periodens egen længde i timer — en kvote kan aldrig være længere.
 * Én tabel, så prisperiode-formularen og listen ikke kan komme til at kalde dem forskelligt.
 */
export const BOOKING_LIMIT_PERIODS: { id: BookingLimitPeriod; name: string; hours: number }[] = [
  { id: BookingLimitPeriod.Day, name: 'Døgn', hours: 24 },
  { id: BookingLimitPeriod.Week, name: 'Uge', hours: 168 },
  { id: BookingLimitPeriod.Month, name: 'Måned', hours: 744 },
];

export enum UserStatusEnum {
  Registered = 0,
  EmailConfirmed = 1,
  WaitingForApproval = 2,
  Approved = 3,
  Suspended = 4,
  Rejected = 5,
  Deleted = 6,
  Banned = 7,
}

export enum UserSubscriptionStatus {
  Pending = 1,
  Trial = 2,
  Active = 3,
  PaymentFailed = 4,
  Deactivated = 5,
  Cancelled = 6,
  Expired = 7,
}

/** The statuses in Danish — the same words the customer app shows the member (subscription-cta.ts). */
export const USER_SUBSCRIPTION_STATUS_LABELS: Record<UserSubscriptionStatus, string> = {
  [UserSubscriptionStatus.Pending]: 'Afventer',
  [UserSubscriptionStatus.Trial]: 'Prøveperiode',
  [UserSubscriptionStatus.Active]: 'Aktiv',
  [UserSubscriptionStatus.PaymentFailed]: 'Betalingsfejl',
  [UserSubscriptionStatus.Deactivated]: 'Deaktiveret',
  [UserSubscriptionStatus.Cancelled]: 'Afmeldt',
  [UserSubscriptionStatus.Expired]: 'Udløbet',
};

export enum Tenant {
  ABOOK = 1,
  KMD = 2,
  BILLETTEN = 3,
}
